// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresWinnerAddBody = {
  poolId: string;
  gridId: string;
  eventId: string;
  squareKey?: string | null;
  topDigit?: number | null;
  sideDigit?: number | null;
  labelKey:
    | "q1"
    | "half"
    | "q3"
    | "p1"
    | "p2"
    | "after3"
    | "after5"
    | "after7"
    | "final"
    | "custom";
  customLabel?: string | null;
};

export type typeSquaresWinnerAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    winner: {
      winnerId: string;
      gridId: string;
      eventId: string;
      labelKey:
        | "q1"
        | "half"
        | "q3"
        | "p1"
        | "p2"
        | "after3"
        | "after5"
        | "after7"
        | "final"
        | "custom";
      label: string;
      source: "auto" | "admin";
      sourceNote: "setAutomatically" | "setByAdmin" | "addedByAdmin";
      squareKey?: string | null;
      topDigit: number;
      sideDigit: number;
      ownerKind?: "member" | "guest" | null;
      ownerId?: string | null;
      displayName?: string | null;
      initials?: string | null;
      isGuest: boolean;
      homeScore: number;
      awayScore: number;
    };
    replacedWinnerId?: string | null;
  };
};

export type typeSquaresWinnerAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresWinnerAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresWinnerAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresWinnerAddBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    squareKey: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    topDigit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    sideDigit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    labelKey: {
      type: "string",
      enum: [
        "q1",
        "half",
        "q3",
        "p1",
        "p2",
        "after3",
        "after5",
        "after7",
        "final",
        "custom",
      ],
    },
    customLabel: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "gridId", "eventId", "labelKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresWinnerAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresWinnerAddBody);
  }

  return async function postSquaresWinnerAdd(
    payload: typeSquaresWinnerAddBody,
  ): Promise<typeSquaresWinnerAddOutput200 | typeSquaresWinnerAddOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresWinnerAdd" failed before calling the network. #53ec9546f0b0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#53ec9546f0b0" },
        },
        data: null,
      } as typeSquaresWinnerAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/winner-add`,
      httpMethod: "POST",
      options,
    })) as typeSquaresWinnerAddOutput200 | typeSquaresWinnerAddOutput400;
  };
}
